import { el, mount, onTap } from './dom.ts';
import { navigate } from '../router.ts';
import { BRAND, brandMark } from './brand.ts';
import { t } from '../i18n/index.ts';
import { legalContent } from '../i18n/legal.ts';
import { langSwitch } from './lang-switch.ts';
import { leaveShell } from './shell.ts';

// Açık zeminli "sayfa" düzeni: landing'in üst çubuğu ve alt bilgisi ile
// herkese açık içerik (yasal metinler, uyumluluk). Uygulama kabuğunu
// KULLANMAZ: oturumsuz ziyaretçi landing'den bir yasal bağlantıya tıkladığında
// koyu uygulama ekranına düşmesi kafa karıştırıyordu.

export function paperPage(...body: Array<Node | null>): void {
  leaveShell();
  document.body.classList.add('on-paper');
  const app = document.getElementById('app')!;

  const brand = el('button', { class: 'wordmark', type: 'button', 'aria-label': `${BRAND.title} — ${t('nav.home')}` },
    brandMark(26), el('span', {}, BRAND.name));
  onTap(brand, () => navigate('/'));

  const login = el('button', { class: 'nav-text', type: 'button' }, t('landing.nav.login'));
  onTap(login, () => navigate('/login'));

  const footerBrand = brand.cloneNode(true) as HTMLElement;
  onTap(footerBrand, () => navigate('/'));

  mount(app, el('div', { class: 'landing paper-page' },
    el('header', { class: 'wrap landing-nav' },
      brand,
      el('nav', { class: 'navlinks' }, langSwitch(), login),
    ),
    el('main', { class: 'wrap paper-main' }, ...body),
    el('footer', { class: 'wrap landing-footer' },
      footerBrand,
      el('div', { class: 'legal' },
        ...legalContent().sections.map((section) => {
          const button = el('button', { type: 'button' }, section.label);
          onTap(button, () => navigate(`/legal?section=${section.key}`));
          return button;
        }),
      ),
      el('div', { class: 'footer-end' }, el('span', {}, t('landing.footer.tagline')), langSwitch()),
    ),
  ));
  window.scrollTo(0, 0);
}
